import React from 'react';
import RangeInput from '../../../element/rangeinput';
import Title from '../../../element/title';
import clone from 'clone';
import url from '../../../urlhandler/urlHandlerActions';
import { findIndex } from 'underscore';

const $ = jQuery;

class RangeInputPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'values': [],
      'options': [],
      'rangeValues': {},
      'toogle': true,
    };
    this.isEditable = API.isEditable ? true : false;
    this.changeToogle = this.changeToogle.bind(this);
    this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
    this.handleRangeSelect = this.handleRangeSelect.bind(this);
    this.errorMessage = null;
  }
  componentDidMount() {
    const block = clone(this.props.block);
    this.processData(this.props, block);
  }
  componentWillReceiveProps(nextprops) {
    this.processData(nextprops, nextprops.block);
  }
  processData(props, block) {
    this.helperData = clone(this.props.helperData);
    this.block = block;
    this.props = props;
    let options = [];
    let values = this.state.values;
    const rangeValues = {};
    if (this.block.selectedDataType !== null) {
      // taxonomies
      if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
        options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
        this.searchType = 'taxonomies';
        this.searchItem = this.block.selectedTaxonomy;
      } else {
        options = this.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
        this.searchType = 'metakeys';
        this.searchItem = this.block.selectedMetakey;
      }

      // url case
      if (this.props.urlData !== undefined) {
        if (this.state.values.length < 1) {
          values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
        }
      } else {
        values = [];
      }
    }
    // console.log(this.props.block.selectedMetakey);
    for (const key in this.props.urlData) {
      let flag = false;
      const keyPartition = key.split(this.block.selectedMetakey);
      if (keyPartition.length === 2 && keyPartition[0].length === 0) {
        flag = true;
      }
      if (this.props.urlData.hasOwnProperty(key)) {
        if (key.includes('min') && flag) {
          rangeValues.min = parseInt(this.props.urlData[key], 10);
        }
        if (key.includes('max') && flag) {
          rangeValues.max = parseInt(this.props.urlData[key], 10);
        }
      }
    }
    this.setState({
      options, values, rangeValues,
    });
  }
  handleRangeSelect(from, to) {
    const values = [{ start: from !== undefined ? from : 0 }, { end: to !== undefined ? to : 100 }];
    if (this.searchItem) {
      url.push({
        'searchItem': this.searchItem, // keys
        'searchType': this.searchType,
        'searchField': 'rangeInput', // taxonomies or metakeys,
        'metakey': this.searchItem,
        values,
      });
      this.errorMessage = null;
    } else {
      this.errorMessage = 'Please select your metadata first from edit panel';
    }
    this.setState({ rangeValues: { min: from, max: to } });
  }
  changeToogle() {
    const toogle = !this.state.toogle;
    this.setState({ toogle });
  }
  render() {
    this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
    if (REBUILDER.hasOwnProperty(this.metakey)) {
      this.previewData = REBUILDER[this.metakey].previewData ? REBUILDER[this.metakey].previewData : {};
    }
    const rangeClassName = this.props.block.dynamicNameClassCheckBox;
    const HelperClass = this.state.toogle ? 'single-component' : '';
    const ifOpen = this.state.toogle ? 'active' : 'toggle-option';
    let max = Number(this.props.block.maxvalue);
    let min = Number(this.props.block.minvalue);
    const allLayout = clone(this.props.allLayout);
    const options = [];
    let isDataTypeSet = false;
    const index = findIndex(allLayout, { uid: this.props.uid });
    if (index !== -1) {
      const indexOfRange = findIndex(allLayout[index].searchAttr, { viewType: 'rangeinput' });
      if (allLayout[index].searchAttr[indexOfRange].selectedDataType === undefined) {
        this.errorMessage = 'Please select your metadata first from edit panel';
        isDataTypeSet = false;
      } else {
        if (allLayout[index].searchAttr[indexOfRange].selectedDataType.length === 0) {
          this.errorMessage = 'Please select your metadata first from edit panel';
          isDataTypeSet = false;
        } else {
          this.errorMessage = null;
          isDataTypeSet = true;
        }
      }
    }
    if (this.props.block.maxvalue === undefined) {
      max = parseInt(100, 10);
    }
    if (this.props.block.minvalue === undefined) {
      min = parseInt(0, 10);
    }
    if (this.state.rangeValues.min === undefined) {
      this.state.rangeValues.min = parseInt(min, 10);
    }
    if (this.state.rangeValues.max === undefined) {
      this.state.rangeValues.max = parseInt(max, 10);
    }
    const selectedMetakey = this.props.block.selectedMetakey;
    // for (let i = min; i <= max; i++) {
    //   options[i] = 0;
    // }
    // if (this.props.previewData.data !== undefined && selectedMetakey !== undefined && this.props.block.histogramToggle === 'true') {
    //   for (let i = min; i <= max; i++) {
    //     this.props.previewData.data.map((item) => {
    //       if (item.meta[selectedMetakey] === String(i)) {
    //         options[i] += 1;
    //         options[i + 1] = options[i];
    //         options[i + 2] = options[i];
    //         options[i + 3] = options[i];
    //         options[i + 4] = options[i];
    //       }
    //     });
    //   }
    // }
    return (<div className={rangeClassName}>
      <Title
        title={this.props.block.title}
        subtitle={this.props.block.subtitle}
        toogle= {this.state.toogle}
        onToogle = {this.changeToogle}
        selectedToogleViewType = {this.props.block.selectedToogleViewType}
      />
      { this.state.toogle ? <div className={HelperClass}>
      {this.errorMessage !== null && this.isEditable ? <div className={'rq-no-attributes-found' + ' ' + ifOpen}><h3>{this.errorMessage}</h3></div> : null}
      { isDataTypeSet ? <div>
      <RangeInput values={this.state.rangeValues} block={this.props.block} maxvalue={max} minvalue={min} grabRangeSelectValue={this.handleRangeSelect} unit={this.props.block.unit} unitFix={this.props.block.hasOwnProperty('selectedUnitFix') ? this.props.block.selectedUnitFix : 'postfix'} /></div> : null }
      </div> : null}
    </div>);
  }
}

RangeInputPreview.propTypes = {
  'urlData': React.PropTypes.object,
  'block': React.PropTypes.object,
  'helperData': React.PropTypes.object,
  'previewData': React.PropTypes.object,
  'shortcodeKey': React.PropTypes.number,
};

export default RangeInputPreview;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/search/default/rangeinputpreview.js
 **/